import { LANGUAGE_CODES } from "@sum-video/shared/types/language";

export const locales = LANGUAGE_CODES;

export const defaultLocale = "en" as const;

export type Locale = (typeof locales)[number];
